import { Component, OnInit, Input } from '@angular/core';
import {  OpeningClosingHoursRequest } from '../../../models/api-store/opening-closing-hours/opening-closing-hours.request.model';
import { AppointmentOpeningClosingHoursService } from '../../../services/api-store/appointment-opening-closing-hours/appointment-opening-closing-hours.service';
import { SpinnerService } from '../../../services/spinner/spinner.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { FALSE, TRUE } from '../../../utils/config/const';


@Component({
  selector: 'app-choice-hours-modal',
  templateUrl: './choice-hours-modal.component.html'
})
export class ChoiceHoursModalComponent implements OnInit {

  @Input() storeId:number;
  @Input() type:string;


  //Tabella orari
  idOpeningclosinghours: number;
  isValidOpeningclosinghours:boolean = false;
  outputOpeningclosinghoursTable:any = {};
  inputOpeningclosinghoursTable:OpeningClosingHoursRequest;


  constructor(
    private appointmentOpeningClosingHoursService: AppointmentOpeningClosingHoursService,
    private spinner: SpinnerService,
    public activeModal: NgbActiveModal,
    private toastr: ToastrService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.initOpeningClosingHours();
  }

  /**
   * Inizializza i dati della tabella orari
   */
  initOpeningClosingHours(){
      this.inputOpeningclosinghoursTable = new OpeningClosingHoursRequest();
  }

  /*  AZIONI */

  /**
   * Salva modifiche
   */
  saveOpeningclosinghours(){
     let request = this.outputOpeningclosinghoursTable;
     this.activeModal.close(request);
  }

  /**
   * Annulla
   */
  cancel(){
    this.activeModal.close('CLOSE');
  }

  /* AGGIORNA VALORI  */

  /**
   * Aggiorna valori della tabella orari
   * @param $event 
   */
  changeTableHours($event){
    if($event.status === "VALID"){
      this.isValidOpeningclosinghours = (TRUE && $event.touched);
    }else{
      this.isValidOpeningclosinghours = (FALSE && $event.touched);
    }
    this.outputOpeningclosinghoursTable = $event.output;
  }

}

